import { PaymentMethodCode, type PaymentOption } from '@src/domains/payments/types/payment';

// Pix leads; everything else keeps the order the API sent it in.
const LEADING_METHOD_CODES: PaymentMethodCode[] = [PaymentMethodCode.Pix];

const rank = (option: PaymentOption): number => {
  const position = LEADING_METHOD_CODES.indexOf(option.paymentMethod.code);

  return position === -1 ? LEADING_METHOD_CODES.length : position;
};

export const sortPaymentOptions = (options: PaymentOption[]): PaymentOption[] =>
  [...options].sort((a, b) => rank(a) - rank(b));
